import React from "react";
import { Spinner } from "./styles";

const Loading = props => {
  // if (props.error) {
  //   return <div>Error!</div>;
  // } else if (props.pastDelay) {
  if (props.pastDelay) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column"
        }}>
        <Spinner />
        {props.timedOut && (
          <span style={{ fontSize: 10 }}>Just one more second...</span>
        )}
      </div>
    );
  } else {
    return null;
  }

  // } else {
  //   return null;
  // }
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/loading/Loading.js